import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import SelectColor from './components/SelectColor.vue';
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const selectColorVisible = ref(false);
    const handleSetTheme = command => {
      selectColorVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dropdown, _mergeProps(_ctx.$attrs, {
        trigger: "click",
        class: "theme",
        onCommand: handleSetTheme
      }), {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "color"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('msg.theme.themeColorChange')), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
          content: _ctx.$t('msg.navBar.themeChange')
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            id: "guide-theme",
            icon: "change-theme"
          })]),
          _: 1
        }, 8, ["content"])])]),
        _: 1
      }, 16), _createElementVNode("div", null, [_createVNode(SelectColor, {
        modelValue: selectColorVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectColorVisible.value = $event)
      }, null, 8, ["modelValue"])])], 64);
    };
  }
};